import * as _ from 'underscore';
import { Messages } from '../../codegen/Localize';
import { FeatureFlags } from '../FeatureFlags';
import { ListResult } from '../fetchers/ListResult';
import { ActionContext } from '../helpers/ActionContext';
import { ResultHelper } from '../helpers/ResultHelper';
import { SliceableHelper } from '../helpers/SliceableHelper';
import { IRemoteRefreshAgentInfo } from '../models/IRemoteRefreshAgentInfo';
import { IServerUserInfo } from '../models/IServerUserInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { OAuthCredentials } from '../resources/OAuthCredentials';
import { ServerUsers } from '../resources/ServerUsers';
import { IGetUserSettingsResult } from '../ServerApi/requests/GetUserSettingsRequest';
import { IConnectedDevice } from '../ServerApi/types/IConnectedDevice';
import { IOAuthCredential, IOAuthCredentialTypeInfo } from '../ServerApi/types/IOAuthCredential';
import { ISiteUser } from '../ServerApi/types/ISiteUser';
import { AddOAuthCredentialAction } from '../services/AddOAuthCredentialAction';
import { BrowserTitleService } from '../services/BrowserTitleService';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from '../services/ConfirmActionDialog';
import { DeleteConnectedDeviceAction } from '../services/DeleteConnectedDeviceAction';
import { DeleteMyCredentialsAction } from '../services/DeleteMyCredentialsAction';
import { DeleteOAuthCredentialsAction } from '../services/DeleteOAuthCredentialsAction';
import { ErrorState } from '../services/ErrorState';
import { IOAuthCredentialsService } from '../services/OAuthCredentialsService';
import { PersonalAccessTokensScope, PersonalAccessTokensService } from '../services/PersonalAccessTokensService';
import { ServerService } from '../services/ServerService';
import { DefaultAuthenticationProviderId } from '../services/SiteAuthenticationSettingsService';
import { UserSettingsCtrlCommon } from '../services/UserSettingsCtrlCommon';


export class SiteUserSettingsSubplaceCtrl {

  public static $inject = [
    '$scope',
    '$state',
    '$translate',
    'ErrorState',
    'UserSettingsCtrlCommon',

    // resolved in state router
    'isSessionUserSelf',
    'userSettings',
    'userRefreshTokenCount',
    'serverUser',
    'siteUser',
    // Local Services
    'OAuthCredentials',
    'AddOAuthCredentialAction',
    'BrowserTitleService',
    'ConfirmActionDialog',
    'DeleteOAuthCredentialsAction',
    'DeleteMyCredentialsAction',
    'ServerUsers',
    'DeleteConnectedDeviceAction',
    'PersonalAccessTokensService',
    'OAuthCredentialsService',
    'ServerService'
  ];

  constructor(
    private $scope: SiteUserSettingsSubplaceCtrl.Scope,
            $state: ng.ui.IStateService,
            $translate: ng.translate.ITranslateService,
            errorState: ErrorState,
            userSettingsCtrlCommon: UserSettingsCtrlCommon,
            isSessionUserSelf: boolean,
            userSettings: IGetUserSettingsResult,
            userRefreshTokenCount: number,
            serverUser: IServerUserInfo,
            siteUser: ISiteUser,
    private oAuthCredentials: OAuthCredentials,
            addOAuthCredentialAction: AddOAuthCredentialAction,
            BrowserTitleService: BrowserTitleService,
            ConfirmActionDialog: ConfirmActionDialog,
            deleteOAuthCredentialsAction: DeleteOAuthCredentialsAction,
            deleteMyCredentialsAction: DeleteMyCredentialsAction,
            serverUsers: ServerUsers,
            deleteConnectedDeviceAction: DeleteConnectedDeviceAction,
            personalAccessTokensService: PersonalAccessTokensService,
    private oauthCredentialsService: IOAuthCredentialsService,
    private server: ServerService,
  ) {

    // redirect to the error state if we don't have the user's settings.
    if (ResultHelper.hasErrors(userSettings)) {
      errorState.go({
        detailsLocKey: 'userCannotBeAccessed',
        redirectState: 'main.site.users',
        redirectLocKey: 'backToUsers'
      });
    }

    BrowserTitleService.setTitleWithPlaceEntityNameAndSubplaceName({placeEntityName: $scope.objectName, translatableSubplaceName: 'settings'});

    this.failureNotificationContent();
    userSettingsCtrlCommon.initScope($scope, isSessionUserSelf, serverUser, siteUser, userSettings, userRefreshTokenCount);

    // TODO: Replace with a session variable check.  See the fix from http://fogbugz/default.asp?142850 for more details
    $scope.canManageCredentials = true;

    $scope.isSAMLUser = !!siteUser && !!siteUser.authenticationProviderId && siteUser.authenticationProviderId !== DefaultAuthenticationProviderId;

    // Connected devices

    const refreshTokensCallback = personalAccessTokensService.loadTokensIntoScope(<any>$scope, serverUser);

    const refreshConnectedDevices = () => serverUsers.getUserConnectedDevices(serverUser.id)
      .then((devices:IConnectedDevice[]) => $scope.connectedDevices = devices).then(refreshTokensCallback);

    $scope.deleteConnectedDevice = (device:IConnectedDevice, $event:JQueryEventObject) =>
      deleteConnectedDeviceAction.execute(device, serverUser.id, ActionContext.fromEvent($event))
        .then(refreshConnectedDevices);

    personalAccessTokensService.loadActionsIntoScope(<any>$scope, serverUser, isSessionUserSelf, refreshConnectedDevices);

    refreshConnectedDevices();

    // Credentials list

    // TODO: Filter out invalid credentials, needs server support
    $scope.credentialsLists = this.createOAuthCredentialLists();

    const refreshCredentials = () => {
      SliceableHelper.fetchAll(oAuthCredentials.all())
        .then<void>((credentialsListResult: ListResult<IOAuthCredential>) => {
          $scope.credentialsLists = this.createOAuthCredentialLists(credentialsListResult.items);
        });
    };

    refreshCredentials();

    // Initialize credential actions
    const getOauthServerAndRedirect = (typeInfo: IOAuthCredentialTypeInfo) => {
        const displayscope = <SiteUserSettingsSubplaceCtrl.OauthUrlScope>$scope.$new();
        displayscope.description = $translate.instant('addServerName');
        displayscope.input = {
            text: '',
            maxLength: 200
        };
        const dialogInstance = ConfirmActionDialog.open({
            title: $translate.instant('addServerNameTitle'),
            bodyTemplateUrl: 'confirmActionDialogInput.html',
            scope: displayscope,
            position: { reserveHeight: 250 },
            confirmDisabled: () => _.isEmpty(displayscope.input.text),
            actionName:$translate.instant('Add'),
            action: (dialogInstance: IConfirmActionDialogInstance) => {
                addOAuthCredentialAction.attemptAuth(typeInfo.type, 'https://' + displayscope.input.text).then(refreshCredentials);
            }
        });
    };
    $scope.deleteAllCredentials = ($event: JQueryEventObject) =>
      deleteMyCredentialsAction.executeFromEvent($event).then(refreshCredentials);

    $scope.addCredentialHref = (typeInfo: IOAuthCredentialTypeInfo) => addOAuthCredentialAction.href(typeInfo);
    $scope.addCredential = (typeInfo: IOAuthCredentialTypeInfo) => {
       //TFS834312 - For Snowflake OAuth, we need InstanceUrl to redirect to Oauth Page
       if (typeInfo.type === 'snowflake') {
            getOauthServerAndRedirect(typeInfo);
        }
        else {
            addOAuthCredentialAction.attemptAuth(typeInfo.type).then(refreshCredentials);
        }
    };

    $scope.deleteCredential = (oauthCredential: SiteUserSettingsSubplaceCtrl.OAuthCredentialViewModel, $event: JQueryEventObject) =>
      deleteOAuthCredentialsAction.executeFromEvent(Set.fromIdItemArray([oauthCredential.credential]), $event)
        .then(refreshCredentials);

    $scope.testCredential = (oauthCredential: SiteUserSettingsSubplaceCtrl.OAuthCredentialViewModel) => this.testCredential(oauthCredential);

    $scope.$on('$destroy', () => addOAuthCredentialAction.cancelPendingAuthAttempt());
  }

  public failureNotificationContent() {
    const showFailureNotifForEAR: boolean = this.server.isExtractEncryptionEnabledOmniSwitch();
    if(showFailureNotifForEAR && this.server.flowsOnSiteEnabled()) {
      this.$scope.failureNotificationTittle = Messages.refreshOrFlowOrEncryptionRunFailureEmailNotificationSettingSection();
      this.$scope.failureNotificationDetail = Messages.refreshOrFlowOrEncryptionFailureEmailNotificationUserSettingDetail();
      this.$scope.failureNotificationCheckboxLabel = Messages.refreshOrFlowOrEncryptionFailureEmailNotificationUserSettingEnable();
    } else if (showFailureNotifForEAR && !this.server.flowsOnSiteEnabled()) {
      this.$scope.failureNotificationTittle = Messages.refreshOrEncryptionRunFailureEmailNotificationSettingSection();
      this.$scope.failureNotificationDetail = Messages.refreshOrEncryptionFailureEmailNotificationUserSettingDetail();
      this.$scope.failureNotificationCheckboxLabel = Messages.refreshOrEncryptionFailureEmailNotificationUserSettingEnable();
    } else if (!showFailureNotifForEAR && this.server.flowsOnSiteEnabled()) {
      this.$scope.failureNotificationTittle = Messages.refreshOrFlowRunFailureEmailNotificationSettingSection();
      this.$scope.failureNotificationDetail = Messages.refreshOrFlowFailureEmailNotificationUserSettingDetail();
      this.$scope.failureNotificationCheckboxLabel = Messages.refreshOrFlowFailureEmailNotificationUserSettingEnable();
    } else {
      this.$scope.failureNotificationTittle = Messages.refreshFailureEmailNotificationSettingSection();
      this.$scope.failureNotificationDetail = Messages.refreshFailureEmailNotificationUserSettingDetail();
      this.$scope.failureNotificationCheckboxLabel = Messages.refreshFailureEmailNotificationUserSettingEnable();
    }
  }

  private testCredential(oauthCredential: SiteUserSettingsSubplaceCtrl.OAuthCredentialViewModel) {
    oauthCredential.test = { inProgress: true };

    const handleTestResult = (success: any) => {
      oauthCredential.test = {
        success: !!success
      };
    };

    this.oAuthCredentials.test(oauthCredential.credential.id)
      .then(handleTestResult, () => handleTestResult(false));
  }

  private createOAuthCredentialLists(credentials?:IOAuthCredential[]):SiteUserSettingsSubplaceCtrl.OAuthCredentialsList[] {
    const convertToCredentialViewModel = (credential:IOAuthCredential):SiteUserSettingsSubplaceCtrl.OAuthCredentialViewModel => {
      return {credential: credential, test: { enabled: this.oauthCredentialsService.supportsTestConnection(credential.type) }};
    };

    const credentialVMGroupsMap = _.groupBy(credentials, c => c.type);

    // Iterate through all OAuth types, if any is enabled, put it in  the result
    return _.compact(_.map(this.oauthCredentialsService.getAllOAuthCredentialTypes(),
      (typeInfo:IOAuthCredentialTypeInfo) => {
        const oauthCredentialsList:SiteUserSettingsSubplaceCtrl.OAuthCredentialsList = {
          typeInfo: typeInfo,
          addEnabled: this.oAuthCredentials.canAddForConnectionType(typeInfo),
          credentials: _.map(credentialVMGroupsMap[typeInfo.type], convertToCredentialViewModel)
        };

        return (oauthCredentialsList.addEnabled || oauthCredentialsList.credentials.length > 0) ? oauthCredentialsList : null;
      })
    );
  }
}

export module SiteUserSettingsSubplaceCtrl {

  export interface OAuthCredentialViewModel  {
    credential: IOAuthCredential;
    test: {
      inProgress?: boolean;
      success?: boolean;
      // Determine if test button is displayed to customers, as of Q4 2016, we disable them for
      // generic-auth-based WDC credentials. TFS 546010
      enabled?: boolean;
    };
  }

  export interface OAuthCredentialsList {
    typeInfo: IOAuthCredentialTypeInfo;
    addEnabled: boolean;
    credentials?: OAuthCredentialViewModel[];
  }

  export interface RemoteRefreshAgentsScope extends ng.IScope {
    deleteRemoteRefreshAgent(agent: IRemoteRefreshAgentInfo, $event: JQueryEventObject): void;
    remoteRefreshAgents: IRemoteRefreshAgentInfo[];
  }

  export interface OauthUrlScope extends ng.IScope {
      description: string;
      input: {
          text: string;
          maxLength?: number;
      };
  }

  export interface Scope extends UserSettingsCtrlCommon.Scope, RemoteRefreshAgentsScope {
    // Credentials

    canManageCredentials: boolean;

    deleteAllCredentials($event: JQueryEventObject): void;

    addCredential(typeInfo: IOAuthCredentialTypeInfo): void;
    addCredentialHref(typeInfo: IOAuthCredentialTypeInfo): string;

    testCredential(oauthCredential: OAuthCredentialViewModel): any;
    deleteCredential(oauthCredential: OAuthCredentialViewModel, $event: JQueryEventObject): any;

    credentialsLists: OAuthCredentialsList[];

    objectName: string;

    isSAMLUser: boolean;

    remoteAgentManagerEnabled: boolean;

    connectedDevices: IConnectedDevice[];
    deleteConnectedDevice(token: IConnectedDevice, $event: JQueryEventObject): void;

    failureNotificationTittle: string;
    failureNotificationDetail: string;
    failureNotificationCheckboxLabel: string;
  }
}

Module.instance().controller('SiteUserSettingsSubplaceCtrl', SiteUserSettingsSubplaceCtrl);
